{
  "en": {
    "onboarding": {
      "steps": {
        "name": {
          "heading": "What's your name?",
          "headingInternational": "Welcome on board!",
          "paragraph": "We need your full name for your certificates.",
          "paragraphInternational": "Please let us know your name.",
          "submit": "Continue"
        },
        "international": {
          "heading": "Which of these options is most relevant for you?",
          "submit": "Continue",
          "options": {
            "false": "German-language programs 🇩🇪 🇦🇹 🇨🇭",
            "true": "English-language programs 🌎"
          },
          "descriptions": {
            "false": "Recommended for people who speak German (wider range of training courses)",
            "true": "Recommended for people who do not speak German"
          }
        },
        "job": {
          "heading": "What best describes your role?",
          "paragraph": "I am...",
          "submit": "Continue",
          "skip": "Fill in later"
        },
        "company": {
          "heading": "Where do you work?",
          "submit": "Continue",
          "pleaseSelect": "Please select educational institution",
          "noResults": "No results. Please enter your full zip code."
        },
        "country": {
          "heading": "What country do you work in?",
          "paragraph": "We strive to provide you with the best services for your country and school system.",
          "submit": "Continue"
        },
        "grade": {
          "heading": "Where do you teach?",
          "paragraph": "We offer training courses and webinars for all age groups and school types. This information helps us recommend the right content for you.",
          "submit": "Continue"
        },
        "region": {
          "heading": "Where do you work?",
          "paragraph": "By providing this information, you will help us to recommend information & offers specific to your state.",
          "submit": "Continue"
        },
        "subject": {
          "heading": "Which school subjects do you teach?",
          "paragraph": "We offer training courses and webinars for all age groups and school types. This information helps us recommend the right content for you.",
          "submit": "Continue"
        },
        "tool": {
          "heading": "What are you most interested in?",
          "paragraph": "This information allows us to offer suggestions that are tailored specifically to your interests.",
          "submit": "Continue"
        },
        "infoFrom": {
          "heading": "Good to have you on board!",
          "headingReOnboarding": "Finished! Thanks for your contribution.",
          "subHeading": "Your registration was successful.",
          "paragraph": "Just one last question: How did you learn about fobizz?",
          "submit": "Let's start"
        }
      },
      "reOnboarding": {
        "heading": "Welcome back at fobizz tools!",
        "paragraph": "We ask you at regular intervals whether your details are still up to date so that we can still make suitable recommendations.",
        "thanks": "Thank you for taking a moment to do this!",
        "start": "Let's go!",
        "skip": "Not now"
      },
      "labels": {
        "back": "Back",
        "or": "or",
        "skip": "Skip",
        "pleaseSpecify": "Please specify",
        "companyKind": "Educational institution",
        "schoolType": "School type",
        "country": "Country",
        "zipcode": "Zip code",
        "newCompany": "I can't find my educational institution",
        "companyName": "Name of educational institution (please enter without abbreviations)",
        "customSchoolType": "Other school type",
        "customCompany": "What is the institution called?",
        "street": "Street, number",
        "city": "City",
        "searching": "Searching ...",
        "activate": "Activate"
      },
      "enums": {
        "infoFromType": {
          "school_administration": "School administration",
          "colleagues": "Colleagues",
          "instagram": "Instagram",
          "twitter": "Twitter",
          "facebook": "Facebook",
          "pinterest": "Pinterest",
          "linkedin": "LinkedIn",
          "online_search": "Online search",
          "ai_assistant": "AI Assistant",
          "social_media": "Social Media",
          "podcast": "Podcast",
          "event": "Event, trade fair or lecture",
          "custom": "Other"
        },
        "regionCode": {
          "BW": "Baden-Württemberg",
          "BY": "Bavaria",
          "BE": "Berlin",
          "BB": "Brandenburg",
          "HB": "Bremen",
          "HH": "Hamburg",
          "HE": "Hesse",
          "MV": "Mecklenburg-Western Pomerania",
          "NI": "Lower Saxony",
          "NW": "North Rhine-Westphalia",
          "RP": "Rhineland-Palatinate",
          "SL": "Saarland",
          "SN": "Saxony",
          "ST": "Saxony-Anhalt",
          "SH": "Schleswig-Holstein",
          "TH": "Thuringia"
        },
        "toolsByValue": {
          "1": "AI tools",
          "2": "Access teaching materials",
          "3": "Professional development",
          "4": "AI tools for students",
          "5": "Create teaching materials"
        }
      }
    }
  }
}
